<script>
import { defineComponent } from 'vue'
import { curveMonotoneX, line } from 'd3'

export default defineComponent({
    props: {
        series: {
            type: Array,
            default: () => []
        },
        xScale: {
            type: Function,
            default: () => {}
        },
        yScale: {
            type: Function,
            default: () => {}
        },
        xAccessor: {
            type: Function,
            default: () => {}
        },
        yAccessor: {
            type: Function,
            default: () => {}
        },
        width: {
            type: Number,
            default: 0
        },
        lineColor: {
            type: String,
            default: 'black'
        },
    },
    setup(props) {
        const generator = line()
            .y(d => props.yScale(props.yAccessor(d)))
            .x(d => props.xScale(props.xAccessor(d)))
            .curve(curveMonotoneX)

        return {
            generator,
        }
    },
})
</script>

<template>
    <g class="mark">
        <path
            v-for="(data, i) of series"
            :key="i" :d="generator(data.history)"
            :stroke-dasharray="!data.highlighted ? '5,5' : '0'"
            :stroke="lineColor || 'currentColor'"
            stroke-linejoin="round"
            stroke-linecrap="round"
            stroke-width="3"
            fill="none"
        />
    </g>
</template>
